import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: "root"
})
export class ProspectFormService {
  private urlCep = `${environment.API}cep/`;
  private urlProspect = `${environment.API}prospect`;

  constructor(private http: HttpClient) {}

  getEndereco(cep: String): Observable<any> {
    return this.http.get(this.urlCep + cep);
  }

  SalvarCadastro(prospect: Array<any>): Observable<any> {
    return this.http.post(this.urlProspect, prospect);
  }
}
